module.exports = __webpack_public_path__ + "media/images/flags/as-3b86b6876653592c0fa31eb96c570867.svg";